import React, { useRef, useState } from 'react';
import { Button, Stack, Text, useClickOutside } from '@moda/om';
import { formatPrice } from '@moda/portal-stanchions';
import { CartPrice, useCartItems } from '../../hooks/useCart';
import { CheckoutAmazonPayButton } from '../CheckoutPaymentSources/CheckoutAmazonPayButton';
import { CheckoutPayPalButton } from '../CheckoutPaymentSources/CheckoutPayPalButton';
import { CheckoutApplePayButton } from '../CheckoutPaymentSources/CheckoutApplePayButton';

import './StickyCheckoutSection.scss';

interface Props {
  payToday: CartPrice;
  to: string;
  disabled: boolean;
}

export const StickyCheckoutSection: React.FC<Props> = ({ payToday, to, disabled }) => {
  const [closed, setClosed] = useState(true);
  const ref = useRef<HTMLDivElement>(null);
  const handleClickOnCheckout = () => setClosed(false);
  const handleClickOutSide = () => (!closed ? setClosed(true) : null);
  const { availableNowItems, preorderItems } = useCartItems();
  const showApplePayButton =
    availableNowItems.length > 0 && preorderItems.length <= 0 && Number(payToday.price) > 0;

  useClickOutside(ref, handleClickOutSide);

  return (
    <div className="StickyCheckoutSection" ref={ref}>
      {closed ? (
        <Button className="StickyCheckoutSection__checkout-button" onClick={handleClickOnCheckout}>
          <Stack space={0} direction="vertical">
            <Text color="snow" treatment="body2">
              Est. Pay Today* {formatPrice(payToday.currency, payToday.price)}
            </Text>
            <Text color="snow">PROCEED TO CHECKOUT</Text>
          </Stack>
        </Button>
      ) : (
        <Stack space={2} direction="vertical">
          <Button className="StickyCheckoutSection__continue" disabled={disabled} to={to}>
            CONTINUE WITH CREDIT CARD
          </Button>
          <CheckoutPayPalButton id="paypal-button-2" />
          {showApplePayButton && <CheckoutApplePayButton />}
          <CheckoutAmazonPayButton />
        </Stack>
      )}
    </div>
  );
};
